// extracted by mini-css-extract-plugin
export default {"generalContent":"Footer_generalContent__cR7N4","boxText":"Footer_boxText__4e+x2","terceiroTitulo":"Footer_terceiroTitulo__5hJAP","email":"Footer_email__tpB3b"};